import Model from '@/models/Model'

export class Category extends Model {
	public id !: number

	// Default attributes that define the "empty" state.
	public defaults() {
		return {
			id: null,
			parent: 0,
			orderBy: 0,
			name: '',
			description: '',
		}
	}

	// Attribute mutations.
	public mutations() {
		return {
			id: (id: any) => Number(id) || null,
		}
	}

	// Route configuration
	public routes() {
		return {
			create: '/categories',
			fetch: '/categories/{id}',
			patch: '/categories/{id}',
			delete: '/categories/{id}',
		}
	}

	public options() {
		return {
			patch: true,
		}
	}

	get route() {
		return { name: 'edit-category', params: { id: this.id } }
	}

	get errorArray() {
		const errors = this.getErrors()
		const errorsArray: any = []
		Object.keys(errors).forEach((property) => {
			errorsArray.push(errors[property])
		})
		if (errorsArray.length === 0) {
			return 'Failed to save page.'
		}
		return errorsArray
	}
}
